export const cards = {
  all: 'all',
  mc: 'mc',
  visa: 'visa',
};
